<style type="text/css">
  div.full-bg-cover {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: 1;
    transform: translateX(-50%) translateY(-50%);
    background: url("/assets/img/main_game/audio-cover.jpg") no-repeat;
    background-size: cover;
    transition: background 300ms ease-in 200ms;
  }
</style>
<div class="full-bg-cover"></div>
<audio
  class="hidden"
  #audio
  (timeupdate)="onMediaTimeUpdate()"
  (ended)="onMediaEnd()"
  (loadedmetadata)="onLoadedMetadata()"
></audio>
<app-rating-header
  [question]="question"
  [currentItem]="startAt"
  [count]="items.length"
>
</app-rating-header>
<app-media-play
  [underPlay]="underPlay"
  [duration]="duration"
  [currentTime]="currentTime"
  (played)="onPlay($event)"
>
</app-media-play>
<app-vote
  [showVote]="showVote"
  [mediaType]="mediaType"
  [currentItem]="startAt"
  [count]="items.length"
  [underPlay]="underPlay"
  (makeVote)="onVote($event)"
  (makeSubmitVote)="onSubmitVote($event)"
>
</app-vote>
<app-media-control
  [duration]="duration"
  [currentTime]="currentTime"
  [progressValue]="progressValue"
  [underPlay]="underPlay"
  (paused)="onPause($event)"
  (played)="onPlay($event)"
>
</app-media-control>
